// NAV_ITEMS — 8 nhóm gom theo CỤM VIỆC (CEO chốt 03/09/2026). Trước đó là 6
// nhóm chép từ frontend-bk, trong đó nhóm "Vận hành" ôm 26/50 mục — trộn đơn
// hàng, tiền, khách, ảnh, CSKH, chất lượng vào một danh sách không đoán được.
// Xương sống của cách chia mới là bản phân loại sẵn có của bộ hướng dẫn trong
// app (features/page-guide/content/), chỉ tách hai chỗ đang trộn.
// 27/10/2026 (CEO chốt 1a · 2a): chia tiếp thành 13 nhóm theo ĐẦU VIỆC, mỗi
// nhóm 3–9 mục — ba nhóm cũ đã phình 11–16 mục (Tổng quan trộn việc cá nhân
// với bảng giám đốc; Lịch & Nhân sự ôm cả ca lẫn lương; Studio ôm điều phối,
// ảnh, in, chấm chất lượng). Nhóm luôn mở, không thu gọn được (2a).
// Thứ tự nhóm: việc làm hằng ngày lên trên, cài đặt xuống đáy.
// Tabbed bk pages map to a single route + search param:
//   retouch_print → /retouch?tab=print
//   cskh_retouch → /cskh?tab=retouch
//   cskh_upsale → /cskh?tab=upsale
//   cskh_manage → /cskh?tab=manage
//   cskh_booking → /cskh?tab=booking
// Folded entries (see NavItem.alt): suggestions → tab inside /products
import {
  Activity,
  Award,
  AlertTriangle,
  Banknote,
  Bell,
  Building2,
  BarChart3,
  Calendar,
  CalendarCheck,
  CalendarClock,
  CalendarDays,
  CalendarRange,
  ClipboardCheck,
  ClipboardList,
  CreditCard,
  FileCheck,
  FolderOpen,
  Gauge,
  Gift,
  Hand,
  Handshake,
  Contact,
  Images,
  Network,
  Inbox,
  LayoutDashboard,
  MailWarning,
  type LucideIcon,
  Megaphone,
  Flower2,
  MessageCircle,
  Package,
  PackageCheck,
  Paintbrush,
  PieChart,
  Printer,
  Receipt,
  Clapperboard,
  Settings,
  ScrollText,
  ShieldCheck,
  Shirt,
  SlidersHorizontal,
  Star,
  Target,
  Trophy,
  TrendingUp,
  Truck,
  User,
  UserCircle,
  Users,
  Wallet,
  ShieldAlert,
  PackageX,
  Lightbulb,
  ListChecks,
  ScanLine,
  LineChart,
  LayoutGrid,
  Route,
} from "lucide-react";

import { ROLE_LABELS } from "@/lib/auth/role-labels";

export type NavItem = {
  id: string;
  to: string;
  label: string;
  icon: LucideIcon;
  search?: Record<string, string>;
  // Pages folded into this entry as tabs (suggestions lives inside /products).
  // The entry shows when the user can reach any of them and always links the
  // host page — see resolve-nav-item.ts. `to` is the folded page's own route,
  // still mounted; the in-app guide maps it (page-guide/resolve-guide-id.ts).
  alt?: { id: string; to: string }[];
};
export type NavGroup = {
  id: string;
  label: string;
  items: NavItem[];
  /**
   * Gom vào ô "Khác" thu gọn cuối menu. Chỉ `groupQualityForQc` gắn cờ này lúc
   * chạy (vai `qc`, CEO chốt 2a 27/09/2026); NAV_GROUPS không bao giờ đặt, nên
   * menu mọi vai khác không đổi.
   */
  folded?: boolean;
};

export const NAV_GROUPS: NavGroup[] = [
  {
    // Việc của CHÍNH người đăng nhập — ai mở app cũng bắt đầu ở đây. Id giữ
    // "overview" (tên cũ "Tổng quan"): nhóm "Chất lượng" của QC chen ngay sau
    // nhóm có id này (qc-quality-group.ts).
    id: "overview",
    label: "Của tôi",
    items: [
      // "Của tôi" (QĐ 0321 · M8, CEO chốt 7a 09/10/2026): đầu nhóm — gom ca,
      // chấm công, điểm, lương, lỗi, huy hiệu của CHÍNH người đăng nhập về một
      // trang; mỗi thẻ dẫn sang trang chi tiết sẵn có.
      { id: "me", to: "/me", label: "Của tôi", icon: UserCircle },
      // Bộ sưu tập khung & danh hiệu: mục RIÊNG cho dễ tìm (CEO 6c, 19/10/2026) —
      // trước đó là trang con ẩn trong Của tôi, không ai biết có trang này.
      { id: "me_collection", to: "/me/collection", label: "Bộ sưu tập", icon: Award },
      // Dashboard về nhóm "Của tôi" (CEO chốt 2b 27/10/2026): với nhân viên
      // thường đây là trang chủ, đặt dưới chữ "Điều hành" thì họ thấy một nhóm
      // lạ chỉ có đúng một mục. Nhóm "Điều hành" giờ chỉ còn bảng của quản lý
      // nên tự ẩn với người không mở được bảng nào.
      { id: "dashboard", to: "/dashboard", label: "Dashboard", icon: LayoutDashboard },
      // Cửa 1/3 của khung hiệu suất (CEO chốt 01/09/2026): hồ sơ của CHÍNH
      // MÌNH — điểm, tiền thưởng, lỗi, chuỗi ngày sạch. Hai cửa còn lại đứng ở
      // nhóm của việc chúng làm: "Chấm điểm" và "Điều hành khung" ở nhóm
      // Chất lượng & Thi đua.
      { id: "performance", to: "/performance", label: "Hiệu suất của tôi", icon: Gauge },
      // Máy chia đơn Profile (quyết định 0077): suất máy đã gán cho chính mình.
      // Về nhóm "Của tôi" từ 27/10/2026 (CEO chốt 1a) — chợ giơ tay "Nhận đơn"
      // ở lại nhóm Lịch & Ca vì đó là việc của cả đội, không phải của riêng ai.
      { id: "my_dispatch", to: "/my-dispatch", label: "Suất của tôi", icon: CalendarCheck },
      // Khoản chi nhân viên tự khai (QĐ 0283, CEO chốt 2a 02/10/2026): mọi
      // nhân sự tự mở để khai và theo dõi tiền hoàn.
      { id: "my_expense_claims", to: "/expense-claims", label: "Khoản chi của tôi", icon: Receipt },
      // "Kênh nhân sự" (hợp đồng Marketing kenh-nhan-su-erp-v1, CEO 16/10/2026; mẫu
      // duyệt 17/10/2026): nhân sự tự khai kênh, video và theo dõi tiền thưởng của
      // mình. Hiện khi máy chủ bật luồng kenh_nhan_su (nav-content-gates).
      { id: "staff_channel", to: "/kenh-nhan-su", label: "Kênh nhân sự", icon: Clapperboard },
      // "Mượn / trả đồ" (CEO chốt 08/10/2026 1a·2a·3a, 1a·2c): máy quét ngay trong
      // GNPF, lệnh đi qua Center về kho (features/kho-borrow). Hiện khi công tắc
      // KHO_SCANNER_ENABLED bật (nav-content-gates).
      { id: "muon_tra_do", to: "/muon-tra-do", label: "Mượn / trả đồ", icon: ScanLine },
      // "Thông báo của tôi" (20/10/2026): CUỐI nhóm — hộp thư của CHÍNH người
      // đăng nhập trong 90 ngày, lọc / tìm / đánh dấu. Chuông chỉ giữ 50 tin
      // mới nhất; tin cũ hơn đọc lại ở đây.
      { id: "my_notifications", to: "/notifications", label: "Thông báo của tôi", icon: Bell },
    ],
  },
  {
    // Bảng người quản lý mở mỗi sáng: Bảng Giám Đốc trả lời "có gì sắp cháy",
    // Việc cần xem là bản tin máy soạn sẵn. Tách khỏi nhóm "Của tôi" 27/10/2026
    // (CEO chốt 1a): trước đó việc cá nhân và bảng giám đốc nằm chung 12 mục.
    id: "management",
    label: "Điều hành",
    items: [
      // Bảng Giám Đốc (Đợt 1 kiểm soát brand, CEO chốt 29/08/2026).
      { id: "director_board", to: "/director-board", label: "Bảng Giám Đốc", icon: Gauge },
      // Bản tin AI cảnh báo quản lý (QĐ 0428, CEO chốt 20/10/2026): đứng ngay sau
      // Bảng Giám Đốc vì cùng trả lời "hôm nay có gì phải xem" — chuông và thư
      // 22 giờ trỏ thẳng vào đây.
      { id: "ai_briefing", to: "/viec-can-xem", label: "Việc cần xem", icon: ListChecks },
      // Kho Ý Tưởng liên ngành (QĐ 0445, CEO chốt 22/10/2026): mỗi tối máy nghĩ
      // 2 ý mới, CEO + giám đốc mở mỗi sáng cùng nhịp Việc cần xem.
      { id: "idea_bank", to: "/kho-y-tuong", label: "Kho Ý Tưởng", icon: Lightbulb },
    ],
  },
  {
    // Khách và đơn của khách: tạo đơn, duyệt báo giá, tra khách, trả lời chat.
    id: "orders",
    label: "Khách & Đơn hàng",
    items: [
      { id: "orders", to: "/orders", label: "Đơn hàng", icon: ClipboardList },
      // Hàng chờ duyệt báo giá doanh nghiệp (QĐ 0178). Đứng NGAY SAU "Đơn
      // hàng" vì đây là hàng chờ của chính những đơn đó — người duyệt mở nó
      // mỗi sáng như mở hộp thư, không phải đi tìm trong từng đơn một.
      { id: "quote_approvals", to: "/quote-approvals", label: "Duyệt báo giá", icon: FileCheck },
      { id: "customers", to: "/customers", label: "Khách hàng", icon: User },
      { id: "customer_chats", to: "/customer-chats", label: "Chat khách", icon: MessageCircle },
      // Phòng Kinh doanh (QĐ 0483, CEO chốt 17a 28/10/2026): cơ cấu tiểu đội theo
      // HRM, mục tiêu tháng, ghi công doanh số chờ duyệt, chất lượng, bảng tổng.
      { id: "sales_team", to: "/sales-team", label: "Phòng Kinh doanh", icon: Users },
    ],
  },
  {
    // Mọi sổ tiền của chuỗi: thu, két, chi, đối soát, nghĩa vụ. Tách khỏi nhóm
    // đơn hàng 27/10/2026 (CEO chốt 1a); "Sức khoẻ két" kéo về cạnh "Két ca
    // tôi" thay vì nằm ở nhóm báo cáo.
    id: "money",
    label: "Tiền",
    items: [
      { id: "payment", to: "/payments", label: "Thanh toán", icon: CreditCard },
      // Đối soát hoá đơn nhà in theo tháng (gói I màn 8, CEO chốt 8a) — đứng cạnh
      // "Thanh toán" vì cùng là việc soát tiền của kế toán. Chỉ SO SỐ, không ghi
      // sổ chi.
      { id: "printer_invoices", to: "/printer-invoices", label: "Đối soát nhà in", icon: Receipt },
      { id: "cash_drawer", to: "/cash-drawer", label: "Két ca tôi", icon: Banknote },
      { id: "cash_chain", to: "/cash-chain", label: "Sức khoẻ két", icon: Banknote },
      { id: "expenses", to: "/expenses", label: "Chi phí", icon: Wallet },
      // Sổ hạn trọng yếu — hợp đồng thuê, giấy phép, PCCC, bảo hiểm. Cùng là sổ
      // nghĩa vụ tiền bạc của chuỗi, và tiền cọc thuê nhà nằm đúng trong sổ này.
      { id: "obligations", to: "/obligations", label: "Sổ hạn trọng yếu", icon: ScrollText },
    ],
  },
  {
    // Lịch chụp và ca làm. Tách khỏi "Lịch & Nhân sự" (16 mục) 27/10/2026.
    id: "schedule",
    label: "Lịch & Ca",
    items: [
      { id: "schedule", to: "/schedule", label: "Lịch chụp", icon: Calendar },
      // Bảng set chụp theo tầng (QĐ 0518): thợ chọn set, support xem set cần dọn.
      { id: "set_board", to: "/set-board", label: "Bảng set chụp", icon: LayoutGrid },
      { id: "ekip_pool", to: "/ekip-pool", label: "Nhận đơn", icon: Hand },
      // id gạch dưới (khoá PAGE_ACCESS), đường dẫn gạch ngang.
      { id: "branch_shifts", to: "/branch-shifts", label: "Ca vận hành", icon: CalendarClock },
      { id: "half_day_slots", to: "/half-day-slots", label: "Suất buổi 5 tiếng", icon: CalendarClock },
      // Ba mục cùng chủ đề lịch nằm cạnh nhau, nên nhãn phải nói rõ ai dùng
      // mục nào: "Đăng ký ca" (cũ) đứng cạnh "Ca photo/makeup" thì không phân
      // biệt được. Đổi nhãn lễ tân là thay đổi UI có chủ đích, đã chốt
      // 20/08/2026 — không phải lọt tay.
      { id: "letan_shifts", to: "/letan-shifts", label: "Ca lễ tân", icon: CalendarDays },
      { id: "ekip_shifts", to: "/ekip-shifts", label: "Đăng ký ca", icon: CalendarClock },
      // Chấm công đứng SAU các mục ca: ca là thứ xếp trước, chấm công là thứ
      // đối chiếu lại sau khi ca đã chạy.
      { id: "staff_checkins", to: "/staff-checkins", label: "Chấm công", icon: CalendarCheck },
    ],
  },
  {
    // Màn điều phối một cơ sở trong ngày.
    id: "dispatch",
    label: "Điều phối cơ sở",
    items: [
      { id: "store_board", to: "/store-board", label: "Điều phối ảnh thẻ", icon: Activity },
      // Máy chia đơn Profile (quyết định 0077). Đứng NGAY SAU "Điều phối ảnh
      // thẻ": hai bảng cùng là màn điều phối một cơ sở trong ngày — một cho
      // khách ảnh thẻ đang đứng ở quầy, một cho suất Profile đã đặt trước.
      { id: "dispatch_board", to: "/dispatch-board", label: "Bảng suất cơ sở", icon: CalendarRange },
      // Điểm hành vi của máy chia đơn (QĐ 0142 §6.3, CEO chốt 16/09/2026).
      // Đứng ngay sau Bảng suất vì cùng một máy: bảng là suất hôm nay, mục
      // này là vì sao máy xếp người đó xuống dưới.
      { id: "dispatch_points", to: "/dispatch-points", label: "Điểm hành vi", icon: Gauge },
    ],
  },
  {
    // Ảnh từ lúc chụp xong tới lúc sửa xong.
    id: "studio",
    label: "Ảnh & Hậu kỳ",
    items: [
      // Quản lý album (QĐ 0301): một chỗ xem mọi album mình mở được. Đứng NGAY
      // TRƯỚC "Việc thợ chụp": cùng là chỗ thợ tìm ảnh của mình — mục này theo
      // album, mục dưới theo việc phải làm. Đừng chèn vào giữa "Việc thợ chụp"
      // và "Hậu kỳ": hai mục đó phải đứng liền nhau (photo-work/navAccess.test).
      { id: "album_manager", to: "/albums", label: "Quản lý album", icon: FolderOpen },
      { id: "photo_work", to: "/photo-work", label: "Việc thợ chụp", icon: Images },
      { id: "retouch", to: "/retouch", label: "Hậu kỳ", icon: Paintbrush, search: { tab: "list" } },
      // Thẻ "Theo dõi" của Hậu kỳ cho người chỉ vào để XEM (quản lý cụm — CEO chốt
      // 7a 28/10/2026). Người có mục "Hậu kỳ" vào bằng thẻ trong trang, không có mục này.
      { id: "retouch_analytics", to: "/retouch", label: "Theo dõi hậu kỳ", icon: LineChart, search: { tab: "dashboard" } },
      // Kho ảnh nền (QĐ 0353): ảnh hoa / trời / sao / sổ tay cho kiểu ghép "Câu
      // chuyện" của Xưởng ghép + câu soạn sẵn. Marketing tải lên, hậu kỳ / CSKH / sale xem.
      { id: "compose_backdrops", to: "/compose-backdrops", label: "Kho ảnh nền", icon: Flower2 },
    ],
  },
  {
    // Đường đi của một món in: làm file → nhà in → về cơ sở → nhìn lại.
    id: "print",
    label: "In ấn",
    items: [
      { id: "retouch_print", to: "/retouch", label: "Làm file & gửi in", icon: Printer, search: { tab: "print" } },
      // "Làm file & gửi in" ở trên và "Hàng in về cơ sở" ở đây TRÔNG GIỐNG NHAU nhưng là
      // hai đầu việc khác hẳn, đừng gộp: mục trên là bàn của hậu kỳ/CSKH (gửi
      // mẫu, gửi nhà in); mục này là quầy lễ tân cơ sở NHẬN hàng nhà in gửi về
      // — kiểm từng món, trả lại hàng lỗi, giao khách (QĐ 0097).
      { id: "print_ops", to: "/print-ops", label: "Hàng in về cơ sở", icon: Truck },
      // Vận hành in (gói I màn 9): in mất bao lâu, nhà in nào hay lỗi, đơn in lãi
      // bao nhiêu — màn chỉ đọc của giám đốc và trưởng cửa hàng.
      { id: "print_ops_report", to: "/print-ops-report", label: "Vận hành in", icon: Printer },
    ],
  },
  {
    // Việc của phòng CSKH sau khi khách đã chụp xong.
    // "Sửa Hình (CSKH)" trùng tên với mục ở nhóm khác là CỐ Ý giữ (CEO chốt
    // 03/09/2026): tách nhóm là đã hết nhầm, đổi tên thì người quen việc phải
    // học lại từ vựng.
    //
    // 25/09/2026 nhóm này bớt HAI mục, cả hai đều gộp vào "Khiếu Nại":
    // "Tiếng Khách" thành thẻ đầu của trang đó, và "Khiếu Nại (CSKH)" bị bỏ
    // hẳn vì trang Khiếu nại đã làm được mọi thứ thẻ cũ làm (hoàn tiền, chụp
    // lại, sửa lại ảnh, ảnh bằng chứng). Ba mục cạnh nhau bắt người ta phải
    // đoán "vụ này thuộc loại nào" trước khi mở.
    id: "cskh",
    label: "Chăm sóc khách",
    items: [
      { id: "cskh_retouch", to: "/cskh", label: "Sửa Hình (CSKH)", icon: MessageCircle, search: { tab: "retouch" } },
      { id: "complaints", to: "/complaints", label: "Khiếu Nại", icon: AlertTriangle },
      { id: "cskh_upsale", to: "/cskh", label: "Đơn in & bán thêm", icon: PackageCheck, search: { tab: "upsale" } },
      { id: "cskh_booking", to: "/cskh", label: "Booking online", icon: CalendarDays, search: { tab: "booking" } },
      { id: "cskh_manage", to: "/cskh", label: "Quản lý CS", icon: BarChart3, search: { tab: "manage" } },
      { id: "zalo", to: "/zalo", label: "Zalo ZNS", icon: Megaphone },
    ],
  },
  {
    // Chấm người, chấm cơ sở và bảng thi đua — gom về một nhóm 27/10/2026
    // (CEO chốt 1a). Trước đó nằm rải ở Studio, Báo cáo và Sản phẩm.
    id: "quality",
    label: "Chất lượng & Thi đua",
    items: [
      // Bàn làm việc QC (QĐ 0521, CEO 03/11/2026): mỗi loại QC một trang gom việc
      // của nghề mình. Chỉ vai qc mở được (page-access + cổng nội dung).
      { id: "qc_desk", to: "/qc-desk", label: "Bàn làm việc QC", icon: LayoutDashboard },
      // Cửa 2/3 của khung hiệu suất: việc ĐI CHẤM người khác — QC chấm phiếu,
      // kiểm cơ sở, trưởng phòng tick phiếu tuần. Đứng cạnh "Chất lượng nhân
      // sự" (CEO chốt 01/09/2026): nó vốn là một thẻ chìm trong trang hồ sơ cá
      // nhân, người bận bỏ qua, mà họ không chấm thì nhân viên MẤT ĐIỂM OAN.
      { id: "performance_review", to: "/performance/review", label: "Chấm điểm", icon: ClipboardCheck },
      // Soi hành trình khách (QĐ 0521 vòng 4): QC CSKH soi 9 khâu một đơn — ca
      // khiếu nại, sao thấp, máy rút ngẫu nhiên.
      { id: "qc_journey", to: "/qc-desk/hanh-trinh", label: "Soi hành trình khách", icon: Route },
      // Hậu kiểm ảnh gốc (QĐ 0521): QC sửa hình (CEO 2a) và QC chụp ảnh (vòng 3 ·
      // 3a) vào thẳng danh sách đơn chờ soi, không qua Bàn làm việc.
      { id: "qc_raw_review", to: "/qc-desk/hau-kiem", label: "Hậu kiểm ảnh gốc", icon: Images },
      // Ảnh thẻ — mục riêng của QC chụp ảnh (QĐ 0521, vòng 3 · 3a).
      { id: "qc_idphoto", to: "/qc-desk/anh-the", label: "Ảnh thẻ", icon: Contact },
      { id: "qc_board", to: "/qc-board", label: "Chất lượng nhân sự", icon: ShieldCheck },
      { id: "quality", to: "/quality", label: "Đánh Giá", icon: Star },
      // Điểm cơ sở (QĐ 0246): 70% QC chấm tận nơi + 30% máy tự đo.
      { id: "branch_scores", to: "/branch-scores", label: "Điểm cơ sở", icon: Building2 },
      // Bảng QC (QĐ 0297, CEO chốt 3b): một màn gom việc kiểm chất lượng — QC
      // làm tới đâu, ai và cơ sở nào lâu chưa được kiểm, việc khắc phục đang
      // mở, tay chấm, 6 tháng. Đứng sau "Điểm cơ sở" vì cùng là số nhìn lại.
      { id: "qc_overview", to: "/qc-overview", label: "Bảng QC", icon: ListChecks },
      { id: "rankings", to: "/rankings", label: "Xếp hạng", icon: Trophy },
      // Hiệu suất quản lý (CEO chốt 6a, 28/10/2026): đánh giá chính người
      // quản lý — cụm, cơ sở, trưởng cửa hàng, trưởng ca. Đứng sau Xếp hạng.
      { id: "mgmt_performance", to: "/mgmt-performance", label: "Hiệu suất quản lý", icon: Network },
      // Huy hiệu (QĐ 0321 · M8): trang /medals có từ trước mà không có mục menu.
      { id: "medals", to: "/medals", label: "Huy hiệu", icon: Award },
      // Cửa 3/3 của khung hiệu suất: việc của người QUẢN khung — bảng đội,
      // chốt kỳ, đặt mốc, giám sát chấm lệch, cấu hình. Mở vài lần một tháng
      // nên đứng cuối nhóm, KHÔNG chen vào màn mở hằng ngày.
      { id: "performance_admin", to: "/performance/admin", label: "Điều hành khung", icon: SlidersHorizontal },
    ],
  },
  {
    // Hồ sơ người, đồ đạc cơ sở và lương.
    id: "hr",
    label: "Nhân sự & Lương",
    items: [
      { id: "staff", to: "/staff", label: "Nhân sự", icon: Users },
      // Năng suất nhân sự (QĐ 0386): từng người nhận / xong / dở / quá hạn /
      // bị trả về theo ngày, theo tháng. Đứng ngay sau Nhân sự — cùng người
      // xem (lead, cửa hàng, điều hành), cùng câu hỏi "người của mình đang
      // làm thế nào".
      { id: "staff_productivity", to: "/staff-productivity", label: "Năng suất nhân sự", icon: TrendingUp },
      // Đồ mượn từ kho Kiểm kê đã quá hạn trả (CEO chốt 2a, 29/09/2026) — việc
      // của người quản lý nhân sự tiệm, đứng ngay sau Nhân sự.
      { id: "equipment_overdue", to: "/equipment-overdue", label: "Đồ quá hạn", icon: PackageX },
      // Mục Kho (kho-erp v1, CEO duyệt bản mẫu 01/10/2026): đồ đạc cơ sở từ kho
      // tổng. Chỉ hiện khi công tắc KHO_ERP_ENABLED bật (nav-content-gates).
      { id: "kho", to: "/kho", label: "Kho", icon: Package },
      { id: "payroll", to: "/payroll", label: "Bảng lương", icon: Wallet },
      { id: "salary_rules", to: "/salary-rules", label: "Cơ chế lương", icon: Settings },
      { id: "salary_rules_v2", to: "/salary-rules-v2", label: "Cơ chế lương v2", icon: SlidersHorizontal },
      { id: "salary_analytics", to: "/salary-analytics", label: "Phân tích lương", icon: PieChart },
    ],
  },
  {
    // Bán cái gì, kéo khách về thế nào, rồi đọc lại số. Gộp "Sản phẩm & Thi
    // đua" với "Marketing & Báo cáo" 27/10/2026 (CEO chốt 1a); thi đua sang
    // nhóm Chất lượng & Thi đua.
    id: "business",
    label: "Kinh doanh & Marketing",
    items: [
      { id: "products", to: "/products", label: "Sản phẩm & Bảng giá", icon: Package, alt: [{ id: "suggestions", to: "/suggestions" }] },
      { id: "costumes", to: "/costumes", label: "Concept & Trang phục", icon: Shirt },
      { id: "marketing", to: "/marketing", label: "Marketing", icon: Megaphone },
      { id: "businessplan", to: "/business-plan", label: "Kế Hoạch KD", icon: Target },
      { id: "promo", to: "/promos", label: "Ưu đãi", icon: Gift },
      { id: "affiliate", to: "/affiliates", label: "Giới thiệu", icon: Handshake },
      // id gạch dưới vì là khoá tra PAGE_ACCESS; đường dẫn gạch ngang.
      { id: "branch_kpi", to: "/branch-kpi", label: "KPI chi nhánh", icon: Target },
      { id: "reports", to: "/reports", label: "Báo cáo", icon: BarChart3 },
      // Sổ album ngoài đơn (QĐ 0306): ai tạo, khách mở / tải bao nhiêu — dấu hiệu
      // giao ảnh không lên đơn. Chỉ quản trị, giám đốc (gallery.loose.audit).
      { id: "album_ledger", to: "/albums/ledger", label: "Sổ album ngoài đơn", icon: ScrollText },
    ],
  },
  {
    // Đáy menu: thứ đọc một lần rồi thôi, và thứ chỉ người chỉnh hệ thống mở.
    id: "settings",
    label: "Nội quy & Cài đặt",
    items: [
      { id: "regulations", to: "/regulations", label: "Nội quy & Quy trình", icon: ClipboardList },
      // Hộp thư kín "Tố giác & Góp ý" (QĐ 0272, CEO chốt 14a): mục gửi cho mọi
      // nhân sự, mục đọc chỉ cho người có tên trong danh sách đọc — cổng ở
      // features/sealed-inbox/permissions.ts.
      { id: "sealed_inbox", to: "/sealed-inbox", label: "Tố giác & Góp ý", icon: MailWarning },
      { id: "sealed_inbox_reader", to: "/sealed-inbox-reader", label: "Hộp thư kín", icon: Inbox },
      // Chống gian lận (QĐ 0216): gom CHÍN chỗ tín hiệu đang rải khắp hệ về
      // một chỗ. Đặt ở đáy menu vì đây là màn mở khi CẦN soi, không phải việc
      // hằng ngày — và chỉ hai vai mở được.
      { id: "fraud_board", to: "/fraud-board", label: "Chống gian lận", icon: ShieldAlert },
      { id: "ekip_config", to: "/ekip-config", label: "Cấu hình Ekip", icon: Settings },
      {
        id: "dispatch_settings",
        to: "/dispatch-settings",
        label: "Cài đặt máy chia đơn",
        icon: SlidersHorizontal,
      },
      { id: "integrations", to: "/integrations", label: "API keys", icon: Settings },
      { id: "general_settings", to: "/general-settings", label: "Cài đặt chung", icon: Settings },
      // Máy chia việc sửa hình (QĐ 0090, 03/09/2026): công tắc, mức chung, hồ
      // sơ nhận việc + thẻ chỉ định của từng thợ. Đứng cạnh Cài đặt chung vì
      // mở vài lần một tháng; việc hằng ngày của thợ nằm ở /retouch.
      { id: "retouch_dispatch_settings", to: "/retouch-dispatch-settings", label: "Máy chia việc sửa hình", icon: Settings },
    ],
  },
];

// Nhãn vai + màu trên thanh bên. Màu là mã nhận diện (đỏ = Tổng Giám đốc,
// nâu = Giám đốc…) nên đứng ngoài token theme. TÊN vai thì KHÔNG khai ở đây:
// lấy từ `lib/auth/role-labels.ts` (một mã một tên, 09/10/2026) — bảng này
// từng tự đặt "Admin", "Giám Đốc", "Kinh doanh", "Điều phối (đã khoá)" khác
// hẳn màn Nhân sự. Phải phủ ĐỦ ALL_ROLES: useSidebarData rơi về
// `identity.role` khi thiếu khoá, nên vai không có dòng sẽ lộ mã máy
// ("branch_manager"). Bài kiểm __tests__/roleLabels.test.ts khoá lại điều này.
const ROLE_COLORS = {
  admin: "#C0392B",
  director: "#8B6914",
  // Vai chuỗi (quyết định 0036). Trưởng cửa hàng thừa kế màu cam của Điều phối
  // vì họ thay chỗ vai đó từ 23/08/2026 (quyết định 0050).
  branch_manager: "#E67E22",
  area_manager: "#7D3C98",
  qc: "#1E8449",
  // Trưởng ca (quyết định 0209). Màu xanh dương đậm hơn Trưởng phòng: cùng
  // họ "cấp trên trong ca" nhưng phạm vi hẹp hơn hẳn — đúng MỘT quyền.
  shift_lead: "#1F4E79",
  coordinator: "#909497",
  accounting: "#16A085",
  manager: "#2E86AB",
  sale: "#B9770E",
  staff: "#555E34",
  viewer: "#839192",
} satisfies Record<keyof typeof ROLE_LABELS, string>;

export const ROLES: Record<string, { label: string; color: string }> = {
  ...Object.fromEntries(
    Object.entries(ROLE_COLORS).map(([role, color]) => [
      role,
      { label: ROLE_LABELS[role as keyof typeof ROLE_LABELS], color },
    ]),
  ),
  device: { label: "—", color: "#555E34" },
};
